import React from 'react';
import useSWR from 'swr';
import axios from 'axios';
import {
  Alert, Box, Chip, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import { apiHost } from '../../utils/apiHost';

export const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const baseUrl = apiHost().replace(/^https?:\/\//, '');
  return `${protocol}://${baseUrl}`;
};
export const fetcherRilis = (url) => axios.get(url, { withCredentials: true }).then((r) => r.data);

export const waktuLalu = (iso) => {
  if (!iso) return '-';
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return 'baru saja';
  if (m < 60) return `${m} menit lalu`;
  if (m < 60 * 24) return `${Math.round(m / 60)} jam lalu`;
  return new Date(iso).toLocaleString('id-ID', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/** Hook data akun yang memakai aplikasi (superadmin). */
export const usePenggunaAplikasi = (aktif = true) =>
  useSWR(aktif ? `${getApiBaseUrl()}/aplikasi/pengguna` : null, fetcherRilis);

/**
 * Daftar akun per cabang yang memakai aplikasi + versinya. Akun yang hanya memakai web tidak tampil.
 */
export const DaftarPenggunaAplikasi = ({ data, isLoading, error }) => {
  if (isLoading && !data) return <CircularProgress size={24} />;
  if (error) return <Alert severity="error">{error.response?.data?.message || error.message}</Alert>;
  const cabang = data?.data || [];
  if (!cabang.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Belum ada akun yang tercatat memakai aplikasi. Versi tercatat setelah HP memakai aplikasi versi 1.1.0 ke atas.
      </Typography>
    );
  }
  return cabang.map((c) => (
    <Box key={c.cabanguuid || '-'} sx={{ mb: 2.5 }}>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>{c.namacabang} ({c.akun.length} akun)</Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Akun</TableCell>
            <TableCell>Versi</TableCell>
            <TableCell>Perangkat</TableCell>
            <TableCell>Terakhir dipakai</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {c.akun.map((a) => (
            <TableRow key={a.useruuid}>
              <TableCell>
                <Typography variant="body2" fontWeight={600}>{a.nama}</Typography>
                <Typography variant="caption" color="text.secondary">{a.username} · {a.role}</Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {a.versi} <Typography component="span" variant="caption" color="text.secondary">(build {a.build})</Typography>
                <Box>
                  {a.terbaru === true && <Chip size="small" color="success" label="Terbaru" />}
                  {a.terbaru === false && <Chip size="small" color="warning" label="Perlu update" />}
                </Box>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{a.perangkat || '-'}</Typography>
                {a.abi && <Typography variant="caption" color="text.secondary">{a.abi === 'arm64-v8a' ? '64-bit' : a.abi === 'armeabi-v7a' ? '32-bit' : a.abi}</Typography>}
              </TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{waktuLalu(a.terakhirAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  ));
};
